import * as ACTION from 'actions'

export function winners(state=[], action) {
    if(action == null) return  state;

    switch (action.type) {
        case ACTION.FETCH_WINNERS:
            return action.winner;
        default:
            return state
    }
}